import { EspecialidadeListSearchComponent } from './EspecialidadeListSearchComponent'
import { EspecialidadeListToolbar } from './EspecialidadeListToolbar'

export const EspecialidadeListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <EspecialidadeListSearchComponent actions={<EspecialidadeListToolbar />} />
    </div>
  )
}
